import type { HandsetDeviceDto } from '../services/handsetDevices/handsetDeviceService';

export const WTTX_APARELHO_VALUE = 'ROTEADOR WTTX WNC WLD71T5B-PRETO';
export const TIPO_VENDA_VF_24X = 'Venda Facilitada 24x';
export const HANDSET_SELECT_NONE = '';
export const HANDSET_SELECT_WTTX = '__wttx__';
export const HANDSET_SELECT_CATALOG_PREFIX = '__catalog:';

export const PARCELAS_VF = 24;

export function syncHandsetValoresFromTotal(total: number): { valorTotal: number; valorMensal: number } {
  const t = Number(total) || 0;
  return {
    valorTotal: t,
    valorMensal: t > 0 ? Math.round((t / PARCELAS_VF) * 100) / 100 : 0,
  };
}

export function syncHandsetValoresFromMensal(mensal: number): { valorTotal: number; valorMensal: number } {
  const m = Number(mensal) || 0;
  return {
    valorMensal: m,
    valorTotal: m > 0 ? Math.round(m * PARCELAS_VF * 100) / 100 : 0,
  };
}

export function lineHasCatalogHandset(line: {
  handsetDeviceId?: string | null;
  tipoVenda?: string | null;
  aparelho?: string | null;
  aparelhoValorMensal?: number | null;
  aparelhoValorTotal?: number | null;
}): boolean {
  if (line.handsetDeviceId) return true;
  const tipo = (line.tipoVenda ?? '').toLowerCase();
  if (tipo.includes('venda facilitada')) return true;
  if ((line.aparelhoValorMensal ?? 0) > 0 || (line.aparelhoValorTotal ?? 0) > 0) return true;
  const ap = (line.aparelho ?? '').trim();
  return !!ap && ap !== WTTX_APARELHO_VALUE;
}

export function lineHasAnyHandset(line: {
  handsetDeviceId?: string | null;
  tipoVenda?: string | null;
  aparelho?: string | null;
  aparelhoValorMensal?: number | null;
  aparelhoValorTotal?: number | null;
}): boolean {
  if (line.handsetDeviceId) return true;
  const tipo = (line.tipoVenda ?? '').toLowerCase();
  if (tipo.includes('venda facilitada') || tipo.includes('comodato')) return true;
  if ((line.aparelhoValorMensal ?? 0) > 0 || (line.aparelhoValorTotal ?? 0) > 0) return true;
  return !!(line.aparelho ?? '').trim();
}

export function isWttxLine(line: { aparelho?: string | null }): boolean {
  return (line.aparelho ?? '').trim() === WTTX_APARELHO_VALUE;
}

export function handsetSelectValue(line: {
  handsetDeviceId?: string | null;
  aparelho?: string | null;
}): string {
  if (isWttxLine(line)) return HANDSET_SELECT_WTTX;
  if (line.handsetDeviceId) return `${HANDSET_SELECT_CATALOG_PREFIX}${line.handsetDeviceId}`;
  return HANDSET_SELECT_NONE;
}

export type HandsetLinePatch = {
  handsetDeviceId?: string;
  aparelho: string;
  tipoVenda: string;
  aparelhoValorTotal?: number;
  aparelhoValorMensal?: number;
};

export function applyHandsetSelectChange(
  selectValue: string,
  catalog: HandsetDeviceDto[]
): HandsetLinePatch {
  if (selectValue === HANDSET_SELECT_WTTX) {
    return {
      handsetDeviceId: undefined,
      aparelho: WTTX_APARELHO_VALUE,
      tipoVenda: 'Comodato',
      aparelhoValorTotal: undefined,
      aparelhoValorMensal: undefined,
    };
  }
  if (selectValue.startsWith(HANDSET_SELECT_CATALOG_PREFIX)) {
    const id = selectValue.slice(HANDSET_SELECT_CATALOG_PREFIX.length);
    const device = catalog.find((d) => d.id === id);
    if (!device) {
      return { aparelho: '', tipoVenda: 'Sem aparelho', handsetDeviceId: undefined };
    }
    return {
      handsetDeviceId: device.id,
      aparelho: device.nome,
      tipoVenda: TIPO_VENDA_VF_24X,
      aparelhoValorTotal: device.valorTotal,
      aparelhoValorMensal: device.valorMensal,
    };
  }
  return {
    handsetDeviceId: undefined,
    aparelho: '',
    tipoVenda: 'Sem aparelho',
    aparelhoValorTotal: undefined,
    aparelhoValorMensal: undefined,
  };
}
